import httpClient from "./httpClient";

const prefix = "/partners";

export async function unsubscribePartner(
  id: number,
  body: { reasonUnsubscribe: string }
) {
  return (await httpClient.patch(`${prefix}/unsubscribe/${id}`, body)).data;
}

export async function unsubscribeProgrammingPartner(id: number, body: any) {
  return (
    await httpClient.patch(`${prefix}/unsubscribe-programming/${id}`, body)
  ).data;
}

export async function fetchPartner(id: number) {
  return (await httpClient.get(`${prefix}/${id}`)).data;
}

export async function fetchPartners(query: string = "") {
  return (await httpClient.get(`${prefix}${query}`)).data;
}

export async function fetchPlantillaLideres(slots: {
  branchId: number;
  positionId: number;
  shiftId?: number;
}[]) {
  const { data } = (
    await httpClient.post(`${prefix}/plantilla-lideres`, { slots })
  ).data;
  return data;
}

export async function getInfoPositionPartner(id: number) {
  return (await httpClient.get(`${prefix}/get-position-info/${id}`)).data;
}

export async function getSalaryHistory(id: number) {
  return (await httpClient.get(`${prefix}/get-salary-history/${id}`)).data;
}

export async function updateSalaryForHistory(
  id: number,
  body: { newSalary: number; reason?: string; userId?: number }
) {
  return (await httpClient.patch(`${prefix}/update-monthly-salary/${id}`, body))
    .data;
}

export async function updateParnterMessage(
  id: number,
  body: { message: string }
) {
  return (await httpClient.patch(`${prefix}/message/${id}`, body)).data;
}

export async function readPartnersByBranch(id: number, params?: any) {
  return (await httpClient.get(`${prefix}/branch/${id}`, { params })).data;
}

export async function readPartnerByBranches(id: number) {
  return (await httpClient.get(`${prefix}/branch/${id}`)).data;
}

export async function reactivePartner(id: number) {
  return (await httpClient.patch(`${prefix}/reactivate/${id}`)).data;
}

export async function updatePartner(id: number, body: any) {
  return (await httpClient.put(`${prefix}/update-partner/${id}`, body)).data;
}

export async function updateBanDate(id: number, banDate: string) {
  return (await httpClient.patch(`${prefix}/update-ban-date/${id}`, { banDate })).data;
}

export async function updateSalary(id: number, body: any) {
  return (await httpClient.patch(`${prefix}/update-salary/${id}`, body)).data;
}

export async function updateChiliInsurance(
  id: number,
  body: { hasChiliLifeInsurance: boolean }
) {
  return (
    await httpClient.patch(`${prefix}/update-chili-insurance/${id}`, body)
  ).data;
}

export async function updateIMSSSalary(id: number, body: any) {
  return (await httpClient.patch(`${prefix}/update-imss-salary/${id}`, body))
    .data;
}

export async function updateSignature(id: number, body: any) {
  return (await httpClient.patch(`${prefix}/update-signature/${id}`, body))
    .data;
}

export async function fetchPartnerCredentials(id: number) {
  return (await httpClient.get(`${prefix}/get-credentials/${id}`)).data;
}

export async function fetchPartnersIncompleted(query?: string) {
  return (await httpClient.get(`${prefix}/get-pending-partners?${query}`)).data;
}
export type PartnerMissingShiftRow = {
  partnerId: number;
  candidateId: number;
  idShift: number | null;
  firstName: string;
  lastName: string;
  secondLastName: string;
  curp: string;
  branchId: number;
  branchName: string;
  positionId: number;
  positionName: string;
};

export async function getActivePartnersMissingShift() {
  return (await httpClient.get(`${prefix}/active-missing-shift`)).data as {
    total: number;
    data: PartnerMissingShiftRow[];
  };
}

export async function assignPartnerShift(partnerId: number, idShift: number) {
  return (
    await httpClient.patch(`${prefix}/assign-shift/${partnerId}`, { idShift })
  ).data;
}

export async function getUnfilledPositionsAll(params?: {
  limit?: number;
  offset?: number;
  sort?: string;
  order?: string;
  branch?: number;
  type?: string;
}) {
  const res = await httpClient.get(`${prefix}/unfilled-positions-all`, {
    params: params ?? { limit: 500, offset: 0, sort: "branch", order: "asc" },
  });
  return res.data?.data ?? [];
}

export async function savePartnerCredentials(body: {
  email: string;
  partnerId: number;
}) {
  return (await httpClient.post(`${prefix}/save-credentials`, body)).data;
}

export async function deletePartner(id: number) {
  return (await httpClient.delete(`${prefix}/delete-partner/${id}`)).data;
}

export async function fethContractStats() {
  return (await httpClient.get(`${prefix}/contract-stats`)).data;
}

export async function getMessagePartner(id: number) {
  return (await httpClient.get(`${prefix}/get-message-partner/${id}`)).data;
}

export async function saveMessagePartner(body: {}) {
  return (await httpClient.post(`${prefix}/save-message-partner`, body)).data;
}

export async function updateMessagePartner(id: number, body: {}) {
  return (await httpClient.put(`${prefix}/update-message-partner/${id}`, body))
    .data;
}

export async function updateUserSchedule(id: number, body: {}) {
  return (await httpClient.post(`${prefix}/update-user-schedule/${id}`, body))
    .data;
}

export async function getUserSchedule(id: number) {
  return (await httpClient.get(`${prefix}/get-user-schedule/${id}`)).data;
}

export async function cancelProgramingPartner(id: number) {
  return (await httpClient.patch(`${prefix}/cancel-programming/${id}`)).data;
}

export async function getBranchesStats() {
  return (await httpClient.get(`${prefix}/branch-stats/all`)).data;
}

export async function getUnfilledPositionsPaginated(queryString: string) {
  return (await httpClient.get(`${prefix}/unfilled-positions-all?${queryString}`))
    .data;
}

export async function getUnfilledPositionByBranch(id: number) {
  return (await httpClient.get(`${prefix}/unfilled-positions/${id}`)).data;
}

export async function getHiredPositionByBranch(id: number) {
  return (await httpClient.get(`${prefix}/hired-positions/${id}`)).data;
}

export async function getOverlappedPositionByBranch(id: number) {
  return (await httpClient.get(`${prefix}/overlapped-positions/${id}`)).data;
}

export async function getTemplateLeader() {
  return (await httpClient.get(`${prefix}/leaders-report`)).data;
}

export async function getUnmatchedPartners(id: number) {
  return (await httpClient.get(`${prefix}/unmatched-positions/${id}`)).data;
}

export async function autocompletePartners(value?: string, branchId?: number) {
  let query = `search=${value || ""}`;
  if (branchId) {
    query += `&branchId=${branchId}`;
  }
  return (await httpClient.get(`${prefix}/autocomplete?${query}`)).data;
}

export async function getAllActivePartners() {
  return (await httpClient.get(`${prefix}/all-active`)).data;
}

export async function findChipsAvailable(id: number) {
  return (await httpClient.get(`${prefix}/find-chips-available/${id}`)).data;
}

export async function saveChipsAvailable(id: number, chips: string[]) {
  return (
    await httpClient.post(`${prefix}/save-chips-available/${id}`, { chips })
  ).data;
}

export async function updateIsVacationsResponsible(
  id: number,
  body: { isVacationsResponsible: boolean }
) {
  return (
    await httpClient.patch(`${prefix}/update-vacations-responsible/${id}`, body)
  ).data;
}

export async function getUnsubscribeStats(
  days?: number,
  startDate?: string,
  endDate?: string
) {
  let url = `${prefix}/stats/unsubscribes`;
  const params = new URLSearchParams();

  if (startDate && endDate) {
    params.append("startDate", startDate);
    params.append("endDate", endDate);
  } else if (days) {
    params.append("days", days.toString());
  } else {
    params.append("days", "30");
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return (await httpClient.get(url)).data;
}

export async function getStaffByPosition() {
  return (await httpClient.get(`${prefix}/stats/by-position`)).data;
}

export async function fetchImssContractStats() {
  return (await httpClient.get(`${prefix}/imss-contract-stats`)).data;
}

export interface ContractsReportQuery {
  branchId?: number;
  search?: string;
  page?: number;
  limit?: number;
  hasContract?: boolean;
  hasImssContract?: boolean;
  sortBy?: "name" | "clockNumber" | "branch" | "createdAt" | "hasContract" | "hasImssContract";
  sortOrder?: "ASC" | "DESC";
}

export async function fetchContractsReport(
  paramsInput: ContractsReportQuery = {}
) {
  const params = new URLSearchParams();
  const { branchId, search, page, limit, hasContract, hasImssContract, sortBy, sortOrder } =
    paramsInput;

  if (branchId) {
    params.append("branchId", branchId.toString());
  }
  if (search && search.trim()) {
    params.append("search", search.trim());
  }
  if (page) {
    params.append("page", page.toString());
  }
  if (limit) {
    params.append("limit", limit.toString());
  }
  if (typeof hasContract === "boolean") {
    params.append("hasContract", hasContract ? "true" : "false");
  }
  if (typeof hasImssContract === "boolean") {
    params.append("hasImssContract", hasImssContract ? "true" : "false");
  }
  if (sortBy) {
    params.append("sortBy", sortBy);
  }
  if (sortOrder) {
    params.append("sortOrder", sortOrder);
  }

  const query = params.toString() ? `?${params.toString()}` : "";
  return (await httpClient.get(`${prefix}/stats/contracts-report${query}`))
    .data;
}

export async function getRecentUnsubscribes(
  days?: number,
  startDate?: string,
  endDate?: string,
  limit?: number
) {
  let url = `${prefix}/stats/recent-unsubscribes`;
  const params = new URLSearchParams();

  if (startDate && endDate) {
    params.append("startDate", startDate);
    params.append("endDate", endDate);
  } else if (days) {
    params.append("days", days.toString());
  }

  if (typeof limit === "number") {
    params.append("limit", limit.toString());
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return (await httpClient.get(url)).data;
}

export async function getRecentPositionChanges(
  days?: number,
  startDate?: string,
  endDate?: string,
  limit?: number
) {
  let url = `${prefix}/stats/recent-position-changes`;
  const params = new URLSearchParams();

  if (startDate && endDate) {
    params.append("startDate", startDate);
    params.append("endDate", endDate);
  } else if (days) {
    params.append("days", days.toString());
  }

  if (typeof limit === "number") {
    params.append("limit", limit.toString());
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return (await httpClient.get(url)).data;
}

export async function getTransportStatistics() {
  return (await httpClient.get(`${prefix}/stats/transport`)).data;
}

export async function getTransportStatisticsByBranch() {
  return (await httpClient.get(`${prefix}/stats/transport-by-branch`)).data;
}

export async function getTransportChanges(
  days?: number,
  startDate?: string,
  endDate?: string,
  limit?: number
) {
  const params: any = {};
  if (days) params.days = days;
  if (startDate) params.startDate = startDate;
  if (endDate) params.endDate = endDate;
  if (limit) params.limit = limit;
  
  return (await httpClient.get(`${prefix}/stats/transport-changes`, { params })).data;
}

export async function getPositionMovements(
  days?: number,
  startDate?: string,
  endDate?: string,
  limit?: number
) {
  let url = `${prefix}/stats/position-movements`;
  const params = new URLSearchParams();

  if (startDate && endDate) {
    params.append("startDate", startDate);
    params.append("endDate", endDate);
  } else if (days) {
    params.append("days", days.toString());
  }

  if (typeof limit === "number") {
    params.append("limit", limit.toString());
  }

  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  return (await httpClient.get(url)).data;
}

export async function updateRecruitmentDate(
  id: number,
  body: {
    newRecruitmentDate: string;
    reason?: string;
    candidateId?: number;
  }
) {
  return (
    await httpClient.patch(`${prefix}/update-recruitment-date/${id}`, body)
  ).data;
}

export async function getRecruitmentDateHistory(id: number) {
  return (await httpClient.get(`${prefix}/recruitment-date-history/${id}`))
    .data;
}

export async function getPartnerStatusHistory(id: number) {
  return (await httpClient.get(`${prefix}/status-history/${id}`)).data;
}

export async function getPartnerTracking(id: number) {
  return (await httpClient.get(`/tracking-partner/${id}`)).data;
}

export async function getActivePartnersByVacancy(vacancyId: number) {
  return (await httpClient.get(`${prefix}/by-vacancy/${vacancyId}`)).data;
}
